// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2921M","header":"ClearentDisclaimer_header__1Yq3s","inner":"ClearentDisclaimer_inner__P2zdW"};